<script>
  import SearchIcon from "../Common/Icons/SearchIcon.svelte";

  // Props
  export let searchTerm = "";
  export let color = "";
  export let noShadow = false;
  export let buttonSearch = null;
  export let clearSearch = null;
  export let height = 0;
  export let submitOnAnyKey = false;
  export let noMargin = false;
</script>

<div class="search-input-wrapper">
  <div
    class="search-input-icon"
    on:click|preventDefault={buttonSearch(searchTerm) || {}}
    style={`${buttonSearch ? "cursor: pointer;" : ""}${
      color.length ? `color: ${color};` : ""
    }`}
  >
    <SearchIcon />
  </div>
  <label for="keyword" class="screen-reader-text">Search</label>
  <input
    name="keyword"
    type="text"
    placeholder="Search"
    bind:value={searchTerm}
    style={`
      box-shadow: ${noShadow ? "none" : "auto"};
      ${color.length ? `color: ${color}; border: 1px solid ${color};` : ""}
      ${height ? `height: ${height}px;` : ""}
      ${noMargin ? "margin-right: 0px;" : ""}
    `}
    on:keydown={(e) => {
      const { target, key } = e;
      const { value } = target;
      if (
        clearSearch &&
        submitOnAnyKey &&
        value.length === 1 &&
        (key === "Backspace" || key === "Delete")
      ) {
        clearSearch();
      } else {
        submitOnAnyKey
          ? buttonSearch && buttonSearch(value)
          : key === "Enter" && buttonSearch && buttonSearch(value);
      }
    }}
  />
</div>

<style>
  .search-input-wrapper {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: relative;
  }

  .search-input-wrapper input {
    font-family: "Segoe UI", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 30px;
    padding-left: 40px;
    background: #ffffff;
    color: #4a4a4a;
    width: 100%;
  }
  .search-input-icon {
    color: #a8a4a1;
    width: 18px;
    height: 18px;
    background-color: #ffffff;
    position: absolute;
    margin-left: 15px;
  }
</style>
